import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostBesichtigungCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostBesichtigungCommandService],
  exports: []
})
export class PostBesichtigungCommandServiceModule { }
